import React from "react";
import { Link } from "react-router-dom";
import CustomersListTable from "../../components/Customers/CustomersListTable";

const CustomersList = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Customers List</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Customers</li>
          <li>Customers List</li>
        </ul>
      </div>

      <CustomersListTable />
    </>
  );
};

export default CustomersList;
